import { OffcanvasDomain } from "../../../../../_components/Abstractions/OffcanvasDomain";
import { CreateContractorRatePlan } from "./CreateContractorRatePlan";
import { FormDomain } from "../../../../../_components/Forms/FormDomain";
import { WastesRatePlanForm } from "./WastesRatePlanForm";
import { ServicesRatePlanForm } from "./ServicesRatePlanForm";
import * as Yup from "yup";
import { DefinitionRatePlanForm } from "./DefinitionRatePlanForm";
import { useDispatch } from "react-redux";
import { useState } from "react";
import moment from "moment";
import { ratePlansActions } from "../../../../../_store/ratePlan.slice";

export function ContractorPricingOffcanvas({ ratePlanId, contractorId, contractorTypes, intermediaries, addresses, ratePlan, size, btnSize = "md", btnTitle, isClone = false, isUpdate = false }) {
  const title = "Cennik";
  const [showOffCanvas, setShowOffCanvas] = useState(false);
  const form = <CreateContractorRatePlan isClone={isClone} isUpdate={isUpdate} setShowOffCanvas={setShowOffCanvas} ratePlanId={ratePlanId} contractorId={contractorId} ratePlan={ratePlan} contractorTypes={contractorTypes} intermediaries={intermediaries} addresses={addresses}/>;
  return (
    <>
      <OffcanvasDomain
        setShowOffCanvas={setShowOffCanvas}
        showOffCanvas={showOffCanvas}
        btnVariant="outline-primary"
        size={size}
        btnSize={btnSize}
        buttonContent={btnTitle}
        title={title}
        // disabledBtnTrigger={isClone && !ratePlan?.dateTo}
        body={form}/>
    </>);
}

export function ContractorRatePlanForm({ contractorId, defaultValues, setShowOffCanvas }) {
  const dispatch = useDispatch();
  const { ratePlanId } = defaultValues;
  const formControls = <div className="d-flex flex-column gap-2">
    <DefinitionRatePlanForm/>
    <WastesRatePlanForm/>
    <ServicesRatePlanForm/>
  </div>;

  const priceValidationSchema = Yup.number()
  .min(0, "Cena jest wymagana")
  .typeError("Cena jest wymagana");

  const wasteValidationSchema = Yup.object().shape({
    waste: Yup.object().required("Towar jest wymagany").typeError("Towar jest wymagany"),
    price: Yup.number().when("isAdvancedPricing", { is: false, then: priceValidationSchema }),
    priceBaled: Yup.number().when("isAdvancedPricing", { is: true, then: priceValidationSchema }),
    priceLoose: Yup.number().when("isAdvancedPricing", { is: true, then: priceValidationSchema }),
  });

  const serviceValidationSchema = Yup.object().shape({
    service: Yup.object().required("Usługa jest wymagana").typeError("Usługa jest wymagana"),
    // price: Yup.number().when("isAdvancedPricing", { is: false, then: priceValidationSchema }),
  });

  const validationSchema = Yup.object().shape({
    type: Yup.string().required("Typ cennika jest wymagany").typeError("Typ cennika jest wymagany"),
    intermediaryId: Yup.string().nullable().when("isIntermediaryPricing", {
      is: true,
      then: Yup.string().required("Pośrednik jest wymagany")
    }),
    dateFrom: Yup.date().typeError("Data początkowa od jest wymagana"),
    dateTo: Yup.string().nullable().test("dateFrom-vs-dateTo", "Data końcowa nie może być wcześniejsza od daty początkowej", function(value) {
      const { dateFrom: dateFromField } = this.parent;
      if (!value) {
        return true;
      }
      const dateFrom = moment(dateFromField, "YYYY-MM-DD").startOf("day");
      const dateTo = moment(value, "YYYY-MM-DD").startOf("day");
      return dateTo.isSameOrAfter(dateFrom);
    }),
    wastes: Yup.array().of(wasteValidationSchema),
    // .test("areWastesUnique", "Towary nie mogą się powtarzać", function(value) {
    //   const ids = value?.map(x => x.waste?.wasteId);
    //   if (!ids || ids?.length === 0) {
    //     return true;
    //   }
    //
    //   return new Set(ids).size === value?.length;
    // }),
    services: Yup.array().of(serviceValidationSchema).test("areServicesUnique", "Usługi nie mogą się powtarzać", function(value) {
      const ids = value?.map(x => x.service?.serviceId);
      if (!ids || ids?.length === 0) {
        return true;
      }

      return new Set(ids).size === value?.length;
    })
  });

  const onSubmit = async(data) => {
    const wastes = data.wastes?.map(x => {
      const isAdvancedPricing = x.isAdvancedPricing;
      const wasteAdvancedPricing = [];
      if (isAdvancedPricing) {
        wasteAdvancedPricing.push({ wasteFormType: "Baled", price: x.priceBaled });
        wasteAdvancedPricing.push({ wasteFormType: "Loose", price: x.priceLoose });
      }

      return ({
        id: x.id,
        entityId: x.waste?.wasteId,
        wasteKindId: x.wasteKind?.wasteKindId,
        price: !isAdvancedPricing ? x.price : 0,
        pricingType: "Waste",
        isAdvancedPricing: isAdvancedPricing,
        wasteAdvancedPricing: isAdvancedPricing ? wasteAdvancedPricing : null
      });
    });
    const services = data.services?.map(x => {
      const isAdvancedPricing = x.isAdvancedPricing;
      const isWasteAdvancedPricing = x.isWasteAdvancedPricing;
      const serviceAdvancedPricing = [];
      let serviceWastesAdvancedPricing = [];
      if (isAdvancedPricing) {
        serviceAdvancedPricing.push({ servicePricingType: "Ton", price: x.priceTon });
        serviceAdvancedPricing.push({ servicePricingType: "Unit", price: x.priceUnit });
        serviceAdvancedPricing.push({ servicePricingType: "RunningMeter", price: x.priceRunningMeter });
      }

      if (isWasteAdvancedPricing) {
        serviceWastesAdvancedPricing = x.wasteAdvancedPricing.map(w => {
          let pricing = [];
          if(isAdvancedPricing) {
            pricing = [
              { servicePricingType: "Ton", price: w.priceTon },
              { servicePricingType: "Unit", price: w.priceUnit },
              { servicePricingType: "RunningMeter", price: w.priceRunningMeter }
            ]
          } else {
            pricing = [{ servicePricingType: "General", price: w.price }];
          }

          return ({ wasteId: w.wasteId, wasteKindId: w.wasteKindId, pricing: pricing });
        })
      }

      const isServiceAdvancedPricing = isAdvancedPricing || isWasteAdvancedPricing;
      return ({
        id: x.id,
        entityId: x.service?.serviceId,
        price: !isServiceAdvancedPricing ? x.price : 0,
        pricingType: "Service",
        isAdvancedPricing: isServiceAdvancedPricing,
        serviceAdvancedPricing: serviceAdvancedPricing,
        serviceWastesAdvancedPricing: serviceWastesAdvancedPricing
      });
    });
    const items = [ ...wastes, ...services ];
    const multipleRatePlans = data.multipleRatePlans;
    const addressId = !multipleRatePlans && data.addressId !== "" ? data.addressId : null;
    const payload = {
      id: data.ratePlanId,
      contractorId: contractorId,
      addressId: addressId,
      addressesIds: multipleRatePlans && !addressId ? data.addressesIds : null,
      dateFrom: data.dateFrom !== "" ? data.dateFrom : null,
      dateTo: data.dateTo !== "" ? data.dateTo : null,
      intermediaryId: data.isIntermediaryPricing ? data.intermediaryId : null,
      type: data.type,
      remarks: data.remarks,
      originalRatePlanId: data.originalRatePlanId,
      items
    }

    const response = await dispatch(ratePlansActions.upsertRatePlan({ payload }));
    if (!response?.error) {
      dispatch(ratePlansActions.getRatePlans({ id: contractorId }));
      setShowOffCanvas(false);
      // const pageNumber = containersPaging?.pageNumber ?? 1;
    }

    return response;
  };

  return (
    <>
      <FormDomain
        formControls={formControls}
        validationSchema={validationSchema}
        defaultValues={defaultValues}
        onSubmit={onSubmit}
        // buttonText={buttonText}
        successMessage={!ratePlanId ? "Dodano cennik" : "Zaktualizowano cennik"}
        title="Cennik"
        btnSize="small"
        addSubmitFooter={false}
      />
    </>
  );
}